"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ServicesNav = require("./ServicesNav.style");
var _NavItems = _interopRequireDefault(require("../NavItems"));
var _useScreenSize = require("../../../hooks/useScreenSize");
const ServicesNav = _ref => {
  var _menuItems$filter;
  let {
    menuItems,
    openChangePasswordModal
  } = _ref;
  const {
    windowWidth
  } = (0, _useScreenSize.useScreenSize)();
  const hasAskICIS = !!((_menuItems$filter = menuItems.filter(item => {
    var _item$icon;
    return (_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.toLowerCase().includes('askicis');
  })) !== null && _menuItems$filter !== void 0 && _menuItems$filter.length);
  return /*#__PURE__*/_react.default.createElement(_ServicesNav.ServicesNavStyle, {
    "data-testid": "right-nav",
    "data-test-id": "right-nav",
    smallDesktop: windowWidth < 1199,
    hasAskICIS: hasAskICIS
  }, /*#__PURE__*/_react.default.createElement(_NavItems.default, {
    position: "right",
    menuItems: menuItems,
    openChangePasswordModal: openChangePasswordModal
  }));
};
var _default = exports.default = ServicesNav;